module.exports = __webpack_public_path__ + "static/img/2.7f598d63.png";